import { render, staticRenderFns } from "./reporterCollection.vue?vue&type=template&id=218593f3&scoped=true"
import script from "./reporterCollection.vue?vue&type=script&lang=ts"
export * from "./reporterCollection.vue?vue&type=script&lang=ts"
import style0 from "./reporterCollection.vue?vue&type=style&index=0&id=218593f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218593f3",
  null
  
)

export default component.exports